import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import { typographyVariants } from '@mint-lib/tw-components';

type Props = {
  hidden?: boolean;
};

const KnowledgeBaseNoRowOverlay = ({ hidden }: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  if (hidden) return null;

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <div className="flex w-40 flex-col items-center gap-4">
        <Illustration
          className="size-40"
          data-testid="no-row-overlay-kb"
          component="IllustrationEmptyState"
        />
        <p className={typographyVariants({ variant: 'h4' })}>
          {t('No matching files')}
        </p>
      </div>
    </div>
  );
};

export { KnowledgeBaseNoRowOverlay };
